
<template>

 <v-dialog max-width="600px" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
        class="indigo accent-1"
        light small mt-4 absolute middle right ><v-icon>edit</v-icon></v-btn>

    <v-card>
      <v-card-title>
        <h2>Either edit rank name or merge into another rank</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout row>
            <v-flex xs12>
              <v-text-field  v-if="showDialog" autofocus v-model="edittedRank.name" name='rankName' label="Rank Name"
                :rules="[rules.required, rules.min]" />
            </v-flex>
          </v-layout>
          <v-layout row>
              <v-flex xs12>
                <div class="text-xs-left">
                <v-btn  flat outline color="black" @click='showMerge'>
                  <v-icon small left>arrow_right_alt</v-icon>
                 <span>Merge into another Rank</span>
                </v-btn>               
                </div>
              </v-flex>
          </v-layout>
          <v-layout row wrap v-if='showingMerge'>
              <v-flex xs12 my-3 py-3>        
    
                      <div style="margin-top:-30px;border:1px solid white">
                        <div class="grey--text" style='text-align:left'>All the people assigned to the current rank "{{edittedRank.name}}"" 
                          will be moved to the new rank you choose, and the current rank will cease to exist.
                          </div> 
                        <multiselect v-model="mergeToRank" id="ajaxms" label="name" track-by="id"
                          placeholder="Select the rank to merge into - type at least 3 characters to search" open-direction="bottom" :options="toRanks" :multiple="false" :searchable="true"
                          :loading="isLoading" :internal-search="false" :clear-on-select="false" :close-on-select="true" 
                          :options-limit="1000" :limit="1" :limit-text="limitText" :max-height="300"
                          :show-no-results="true" :hide-selected="false" @search-change="loadRanks">
                          <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                              <span>{{ option.name }}</span>
                              <span class="custom__remove" @click="remove(option)">❌</span>
                            </span>
                          </template>
                          <template slot="clear" slot-scope="props">
                            <div class="multiselect__clear" v-if="mergeToRank" @mousedown.prevent.stop="clearAll(props.search)"></div>
                          </template>
                          <span slot="noResult">Oops! No ranks found. Consider changing the search query.</span>
                        </multiselect>
                      </div>
                      <v-btn flat outline color="black" @click='hideMerge'>
                        <v-icon small left>cancel</v-icon>
                        <span>Cancel merge</span>
                      </v-btn> 

              </v-flex>
          </v-layout>
          <provenance-and-note v-bind:record="edittedRank"/>

          <v-layout row>
              <v-flex xs12>
                <div class="error" v-html="error"></div>
              </v-flex>
          </v-layout>

          <v-layout row>          
              <v-flex xs4>
              </v-flex>
              <v-flex xs4>
                <v-btn dark class="indigo darken-1" @click='editRank' :loading="loading"><v-icon left >save_alt</v-icon> {{editButtonPrompt}}</v-btn>
              </v-flex>
              <v-flex xs4>
              </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
 </v-dialog>
</template>        

<script>

import Panel from '@/components/Panel' ;
import RankService from "@/services/RankService" ;

export default {
  components: { Panel }, 
  data () {
    return {
      rank: {},
      edittedRank: {  
        id: parseInt(this.$route.params.id),
        type: this.$route.params.rankType,
        name: '',
        provenance: '',
        note: '',
        mergedToRankId: -1
      },
      title: 'Edit rank',
      error: null,
      message: null,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Minimum of 8 characters is required.'
      },
      mergeToRank: null,
      toRanks: [],
      isLoading: false,
      showingMerge: false,
      editButtonPrompt: "Edit Rank Name",
      loading: false,
      showDialog: false
    }
  },

  async mounted () {
    console.log("in rankedit mounted") ;
    await this.readData() ;
  },

  methods: {
    async editRank () {
      console.log("IN editRank") ; 
      if (!this.$refs.form.validate()) return ;

      this.error = null ;
      if (this.showingMerge) {
        if (!this.mergeToRank) {
          this.error = "Select a rank to merge this rank into" ;
          return ;
        }
        console.log("mergeToRank=" + JSON.stringify(this.mergeToRank)) ;
        try {
          console.log("at 1") ;
          this.loading = true ;
          this.edittedRank.mergedToRankId = this.mergeToRank.id ;
          const response = await RankService.mergeTo(this.edittedRank) ;
          console.log("at 2") ;
          console.log("mergeTo response: " + JSON.stringify(response)) ;

          // this.message = response.data.message
          console.log("success mergeTo, resp data=" + JSON.stringify(response.data)) ;
          this.showDialog = false ;
          this.$store.dispatch('setPendingMessage', {text: "Rank " + this.edittedRank.name + " merged and deleted", color: 'success'}) 
          this.$router.push('/rank/' + response.data.type + "/" + response.data.id) ;
        }
        catch (err) {
          console.log("catch err:" + JSON.stringify(err)) ;
          // console.log("ee=" + err.response.data.error)
          this.error = err.response.data.error  ;
        }
        finally {
          this.loading = false ;
        }
        return ;
      }

      try {
        this.loading = true ;
        const response = await RankService.edit(this.edittedRank) ;
        console.log("editRank response: " + JSON.stringify(response)) ;

        // this.message = response.data.message
        console.log("success edit, resp data=" + JSON.stringify(response.data)) ;
        this.showDialog = false ;        
        this.$renderToastInParent(this, "Rank name successfully changed") ;
        // this.$parent.$parent.updateRankTitle(this.edittedRank.name) ;

        // this.$router.push('/rank/' + response.data.type + "/" + response.data.id + "?nonce=" + Math.random()) ;
      }
      catch (err) {
        console.log("catch err:" + JSON.stringify(err)) ;
        // console.log("ee=" + err.response.data.error)
        this.error = err.response.data.error  ;
      }
      finally {
        this.loading = false ;
      }
    },

    async readData () {
      const result = await RankService.id(this.edittedRank.type, this.edittedRank.id) ;
      this.rank = result.data ;
      // console.log("Back from us, this.rank=" + JSON.stringify(result)) ;
      this.edittedRank.name = this.rank.v ;
      this.edittedRank.type = this.rank.type ;
      this.title = this.$codeToService(this.rank.type) + ": " + this.rank.v ;
    },

    async loadRanks (query) {
      if (query.length < 2) return ;
      this.isLoading = true ;
      const result = await RankService.index(query, this.edittedRank.type, 0, 1000) ;
      const d = result.data ;
      const possibleMergeRanks = [] ;
      for (let i = 0 ; i < d.length ; i++) {
        const du = d[i] ;
        if (du.id === this.edittedRank.id) continue ;  // never include ourself
        du.name += " - " + du.count + ((du.count === 1) ? " person" : " people") ;
        possibleMergeRanks.push(du) 
      }
      this.toRanks = possibleMergeRanks ;
      this.isLoading = false ;
    },

    limitText (count) {
      return `and ${count} other ranks`
    },

    clearAll () {
      this.mergeToRank = null ;
    },

    showMerge () {
      console.log("showMerge clicked") ;
      this.showingMerge = true ;
      this.editButtonPrompt = "Merge (and then delete) Rank" ;
    },
    hideMerge () {
      this.showingMerge = false ;
      this.editButtonPrompt = "Edit Rank Name" ;
      this.mergeToRank = null ;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RankEdit.vue